import { baseAPI } from "./baseService";
import { AUTH, MALSAPI } from "./serviceConstants";

export const authAPI = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getUserAuth: builder.query({
      query: (authenticateOnly) => `${MALSAPI}/${AUTH}/${authenticateOnly?'logged':''}`,
    })
  })
});

export const { useGetUserAuthQuery } =
  authAPI;